import { Component, ViewEncapsulation } from '@angular/core';
import { MonthPerformanceService } from '../service/month-performance.service';
import { KpiDrivingBehavior } from '../model/kpi-driving-behavior';
import { PerformanceMonthSection } from '../model/performance-month-section';
import { KpiITToolUsage } from '../model/kpi-it-tool-usage';
import { KpiEconomy } from '../model/kpi-economy';
import { KpiOthers } from '../model/kpi-others';
import { CommonModule } from '@angular/common';
import { MatToolbarModule } from '@angular/material/toolbar';
import {FormControl, FormsModule, ReactiveFormsModule} from '@angular/forms';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {MatInputModule} from '@angular/material/input';
import {MatFormFieldModule} from '@angular/material/form-field';
import { MatDividerModule } from '@angular/material/divider';
import { MatListModule } from '@angular/material/list';
import {MatExpansionModule} from '@angular/material/expansion';
import { UserProfileService } from '../service/user-profile.service';
import { MatIconModule } from '@angular/material/icon';
import { VjsPlayerComponent } from '../vjs-player/vjs-player.component';
import {MatCardModule} from '@angular/material/card';
import { AttachmentDialogComponent } from '../attachment-dialog/attachment-dialog.component';
import {ThemePalette} from '@angular/material/core';
import {
  MatDialog,
  MAT_DIALOG_DATA,
  MatDialogTitle,
  MatDialogContent,
} from '@angular/material/dialog';
import {MatButtonModule} from '@angular/material/button';
import {MatSelectModule} from '@angular/material/select';
import { VideoDialogComponent } from '../video-dialog/video-dialog.component';

import { TranslateService } from '@ngx-translate/core';
import { TranslateModule } from '@ngx-translate/core';

import { Store, Select } from '@ngxs/store';
import { CommonDataState } from '../shared/stores/common-data.state';

import { Observable } from 'rxjs';
import { RouterLink } from '@angular/router';
import { Location } from '@angular/common';
import { any } from 'video.js/dist/types/utils/events';
import { obj } from 'video.js/dist/types/utils/obj';
@Component({
  selector: 'app-month-performance',
  standalone: true,
  imports: [
    CommonModule,
    MatToolbarModule,
    MatFormFieldModule,
    MatInputModule,    
    FormsModule,
    ReactiveFormsModule,
    MatDividerModule,
    MatListModule,
    MatExpansionModule,
    MatIconModule,
    VjsPlayerComponent,
    MatProgressSpinnerModule,
    MatFormFieldModule, 
    MatSelectModule,
    MatCardModule, 
    MatButtonModule,
    TranslateModule,
    RouterLink,
  ],
  templateUrl: './month-performance.component.html',
  styleUrl: './month-performance.component.css',
  providers: [
    
  ],  
})
export class MonthPerformanceComponent {
  @Select(CommonDataState)
  commonDataState$!: Observable<number>;
  color : ThemePalette = 'accent';
  selectedMonth = 'YTD';
  showVideoPlayer = false;
  isLoading = false;
  apexId!:string;
  panelOpenState = false;
  monthPerformanceObjectArray!:any[];
  PerformanceMonthSectionKpiDrivingBehavior: PerformanceMonthSection<KpiDrivingBehavior> | undefined;
  PerformanceMonthSectionKpiITToolUsage:PerformanceMonthSection<KpiITToolUsage> | undefined;
  PerformanceMonthSectionKpiEconomy:PerformanceMonthSection<KpiEconomy> | undefined;
  PerformanceMonthSectionKpiOthers:PerformanceMonthSection<KpiOthers> | undefined;
  PerformanceMonthSectionArray: Array<PerformanceMonthSection<any>> = [];
  categoryNameSortIdMap:Map<string, any> = new Map();
  kpiNameSortIdMap:Map<string, any> = new Map();
  categoryKpiArrayMap:Map<string, any> = new Map();
  yes = '';
  no = '';
  thisYear = '';
  lastYear = '';
  // monthArray = this.getMonthArray();
  monthArray!: any[];
  browserLangToUse = '';
  constructor(
    private userProfileService: UserProfileService,
    public monthPerformanceService: MonthPerformanceService,
    public dialog: MatDialog,
    public translate: TranslateService,
    private location: Location,
  ) { 
      translate.setDefaultLang('en');
      let browserLangToUse = '';
      let browserLang = translate.getBrowserCultureLang();
      browserLangToUse = browserLang === undefined ? 'en' : browserLang;
      translate.use(browserLangToUse);
      console.log(browserLangToUse);
      this.browserLangToUse = browserLangToUse;
      translate.get('ml_143931').subscribe((res: string) => {
        this.yes = res;      
      });
      translate.get('ml_143932').subscribe((res: string) => {
        this.no = res;
      });
      translate.get(['ml_151127', 'ml_151454']).subscribe((res: any) => {
        console.log(res);
        this.thisYear = res.ml_151127;
        this.lastYear = res.ml_151454;
        this.monthArray = this.getMonthArray();
      });
  }  
  getFormattedDateString(dateObject: Date):string{    
    // const offset = dateObject.getTimezoneOffset()
    // dateObject = new Date(dateObject.getTime() - (offset*60*1000))
    return dateObject.toISOString().split('T')[0]
  }
  setMonthAndYearFromSelect(value:any){    
    
    this.isLoading = true;
          
    if(value === 'YTD' || value === 'LY'){      
      let overrideObjectString = localStorage.getItem("overrideObject");
      if(overrideObjectString === null){
        let apexId = localStorage.getItem("apexid"); 
        let country = localStorage.getItem("driverCountry")!;
        let businessType = localStorage.getItem("driverBusinessType")!;
        if(apexId !== null){
          this.getYearPerformanceByApexIdMonthCountryBusinessType(apexId, country, businessType, value); 
        }          
      }
      else{
        let overrideObject = JSON.parse(overrideObjectString);
        let apexId = overrideObject.apexid;
        let country = overrideObject.driverCountry;
        let businessType = overrideObject.driverBusinessType;
        this.getYearPerformanceByApexIdMonthCountryBusinessType(apexId, country, businessType, value);
      }          
    }
    else{              
      let overrideObjectString = localStorage.getItem("overrideObject");
      if(overrideObjectString === null){
        let apexId = localStorage.getItem("apexid"); 
        let country = localStorage.getItem("driverCountry")!;
        let businessType = localStorage.getItem("driverBusinessType")!;
        if(apexId !== null){
          this.getMonthPerformanceByApexIdMonthCountryBusinessType(apexId, value + '-01', country, businessType);
        }          
      }
      else{
        let overrideObject = JSON.parse(overrideObjectString);
        let apexId = overrideObject.apexid;
        let country = overrideObject.driverCountry;
        let businessType = overrideObject.driverBusinessType;
        this.getMonthPerformanceByApexIdMonthCountryBusinessType(apexId, value + '-01', country, businessType);
      }         
    }
       
  }    
  ngOnInit(): void {
    

    let overrideObjectString = localStorage.getItem("overrideObject");
    if(overrideObjectString === null){
      console.log(`team-message-data not override apex id`);
      this.pageInitialization();
    } 
    else{
      console.log(`team-message-data override apex id`);
      this.pageInitializationOverride(overrideObjectString);
    }

    
  }
  ngAfterViewInit(): void {
    // setTimeout(() => { window.scrollTo(0, 1000); }, 100);
  }
  ngAfterViewChecked():void{
    // window.scrollTo(0,1000);
    // setTimeout(() => { window.scrollTo(0, 1); }, 100);
  }
  private pageInitialization(): void {
    this.isLoading = true;
    let apexId = localStorage.getItem("apexid");
    this.apexId = apexId!;     
    let country = localStorage.getItem("driverCountry")!;
    let businessType = localStorage.getItem("driverBusinessType")!;
    if(apexId !== null){      
      // this.apexId = apexId;  
      this.getYearPerformanceByApexIdMonthCountryBusinessType(apexId, country, businessType, 'YTD');    
    }
  }
  getYearPerformanceByApexIdMonthCountryBusinessType(apexid:string, country:string, businessType:string, yearValue: string):void{        
    if(yearValue === 'YTD'){
      let date = new Date();
      console.log(date);
      date.setHours(0, 0, 0, 0);
      let startDay = this.getStartDate(date);
      let formattedStartDayString = this.getFormattedDateString(startDay);
      console.log(startDay);
      console.log(startDay.toISOString());
  
      let endDay = date;
      endDay.setHours(23, 59, 59, 999);
      let formattedEndDayString = this.getFormattedDateString(endDay);
      console.log(endDay);
      console.log(endDay.toISOString());

      this.monthPerformanceService.getYearPerformanceByApexIdMonthCountryBusinessType(apexid, formattedStartDayString, formattedEndDayString, country, businessType)
      .subscribe(responseMonthPerformanceObjectArray => {              
        this.monthPerformanceObjectArray = responseMonthPerformanceObjectArray;
        this.getSummary(this.monthPerformanceObjectArray);
        this.isLoading = false;
      });
    }
    else{
      let date = new Date();
      console.log(date);
      let startDay = this.getStartDate(date);
      let lastYearStartDay = new Date(startDay.getFullYear() - 1, 9, 1, 0, 0, 0, 0);
      let formattedLastYearStartDayString = this.getFormattedDateString(lastYearStartDay);
      console.log(lastYearStartDay);
      console.log(lastYearStartDay.toISOString());

      let lastYearEndDay = new Date(lastYearStartDay.getFullYear() + 1, 9, 0, 23, 59, 59, 999);
      let formattedLastYearEndDayString = this.getFormattedDateString(lastYearEndDay);
      console.log(lastYearEndDay);
      console.log(lastYearEndDay.toISOString());

      this.monthPerformanceService.getYearPerformanceByApexIdMonthCountryBusinessType(apexid, formattedLastYearStartDayString, formattedLastYearEndDayString, country, businessType)
      .subscribe(responseMonthPerformanceObjectArray => {              
        this.monthPerformanceObjectArray = responseMonthPerformanceObjectArray;
        this.getSummary(this.monthPerformanceObjectArray);
        this.isLoading = false;
      });
    }        
  }  

  getStartDate(date: Date): Date {
    if( date >= new Date(date.getFullYear(), 9, 1, 0, 0, 0, 0) && date < new Date(date.getFullYear() + 1, 0, 1, 0, 0, 0, 0) ){
      return new Date(date.getFullYear(), 9, 1, 0, 0, 0, 0);
    }  
    else{
      return new Date(date.getFullYear() - 1, 9, 1, 0, 0, 0, 0);
    }
  }

  getMonthPerformanceByApexIdMonthCountryBusinessType(apexid:string, month:string, country:string, businessType:string):void{
    console.log(month);
    let targetMonthStart = new Date(Number(month.split('-')[0]), Number(month.split('-')[1]) - 1, Number(month.split('-')[2]));
    console.log(targetMonthStart);
    let targetMonthEnd = new Date(targetMonthStart.getFullYear(), targetMonthStart.getMonth() + 1, 0, 23, 59, 59, 999);
    console.log(targetMonthEnd);
    let formattedStartDayString = targetMonthStart.toISOString().split('T')[0];
    console.log(targetMonthStart.toISOString());
    console.log(formattedStartDayString);
    let formattedEndDayString = targetMonthEnd.toISOString().split('T')[0];
    console.log(targetMonthEnd.toISOString());
    console.log(formattedEndDayString);
    this.monthPerformanceService.getMonthPerformanceByApexIdStartEndMonthCountryBusinessType(apexid, formattedStartDayString, formattedEndDayString, country, businessType).subscribe(responseMonthPerformanceObjectArray => {      
      this.monthPerformanceObjectArray = responseMonthPerformanceObjectArray;
      this.getSummary(this.monthPerformanceObjectArray);
      this.isLoading = false;
    });
    
  }
  private pageInitializationOverride(overrideObjectString:string): void{
    let overrideObject = JSON.parse(overrideObjectString);
    let apexid = overrideObject.apexid;
    this.apexId = apexid;
    let country = overrideObject.driverCountry;
    let businessType = overrideObject.driverBusinessType;
    this.isLoading = true;
    this.getYearPerformanceByApexIdMonthCountryBusinessType(apexid, country, businessType, 'YTD');
  }
  openDialog(kpi:any) {
    this.dialog.open(AttachmentDialogComponent, {
      maxWidth: '100vw',
      maxHeight: '100vh',
      height: '100%',
      width: '100%',
      data: {
        kpi: kpi,
      },
    });
  }
  openVideoDialog(kpi:any) {
    this.dialog.open(VideoDialogComponent, {
      maxWidth: '100vw',
      maxHeight: '100vh',
      height: '100%',
      width: '100%',
      data: {
        kpi: kpi,
      },
    });
  }  
  getMonthArray(): any[] {
    let monthArray: any[] = [];
    let date = new Date();
    monthArray.push({ textValue: 'YTD', textString: this.thisYear });
    monthArray.push({ textValue: 'LY', textString: this.lastYear });
    for (let i = 0; i < 12; i++) {
      // let monthString = date.toISOString()!.split('T')[0].substring(0, 7);
      let monthString = this.convertDateToString(date);
      let arrayObject: any = { textValue: monthString, textString: monthString };
      monthArray.push(arrayObject);

      let previousMonth = this.getPreviousMonth(date);
      date = previousMonth;
      // let monthString = previousMonth.toISOString()!.split('T')[0].substring(0, 7);
            
    }
    return monthArray;
  }
  convertDateToString(date: Date):string {
    var d = new Date(date),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();

    if (month.length < 2) 
        month = '0' + month;
    if (day.length < 2) 
        day = '0' + day;

    return [year, month].join('-');
  }
  getPreviousMonth(date: Date): Date {
    const clone = new Date(date);    
    clone.setDate(0);
    return clone;
  }
  formatDate(dateString:string): string{
    return new Date(dateString).toLocaleString();
  }
  sumOccurrence(kpiResults:any[]): number{
    let occurrenceTotal = 0;    
    for (let step = 0; step < kpiResults.length; step++) {
      occurrenceTotal = occurrenceTotal + kpiResults[step].occurrence;
    }
    return occurrenceTotal;
  }
  sumTargetOccurrence(kpiResults:any[]): number{
    let targetOccurrenceTotal = 0;
    for (let step = 0; step < kpiResults.length; step++) {
      targetOccurrenceTotal = targetOccurrenceTotal + kpiResults[step].targetOccurrence;
    }
    return targetOccurrenceTotal;
  }
  sumViolation(kpiResults:any[]): number{
    let violationTotal = 0;
    for (let step = 0; step < kpiResults.length; step++) {
      if(kpiResults[step].compliance !== null  ){
        if(kpiResults[step].compliance){

        }
        else{
          violationTotal = violationTotal + 1;
        } 
      }
           
    }
    return violationTotal;
  }
  showExpansionByTargetKpi(kpiName:string): boolean{
    let showOrHide = false;
    if(kpiName === 'APT Compliance' || kpiName === 'eVCR Compliance'){

    }
    else{
      showOrHide = true;
    }
    return showOrHide;
  }
  getAptCompliance(kpiResults:any[]):boolean{
    let compliance = true;
    for(let step = 0; step < kpiResults.length; step++){
      if(kpiResults[step].compliance === false){
        compliance = false;
      }
    }
    return compliance;
  }
  getCountOfFalseCompliance(kpiResults:any[]):number{
    let count = 0;
    count = kpiResults.filter((kpi) => kpi.compliance === false).length;
    return count;
  }
  backClicked() {
    this.location.back();
  }
  getSummary(performanceObjectArray: any[]): void {
    if(performanceObjectArray.length === 0){
      
    }
    else{
      for(let performanceObject of performanceObjectArray){
        if(performanceObject.catergoryId === 'B'){
          performanceObject.summaryCount = 0;
          for(const kpi of performanceObject.kpis){
            
            
            if(kpi.kpiName !== 'Driver Observation'){
              performanceObject.summaryCount = performanceObject.summaryCount + kpi.kpiResults.length;
            }
            else{
              const falseComplianceCount = kpi.kpiResults.filter((kpiResult: any) => kpiResult.compliance === false).length;
              if(falseComplianceCount > 0){
                performanceObject.summaryCount = performanceObject.summaryCount + falseComplianceCount;
              } 
            }
          }
        }
        if(performanceObject.catergoryId === 'I'){
          performanceObject.summaryCount = 0;
          performanceObject.falseComplianceCount = 0;
          performanceObject.hasData = false;
          for(const kpi of performanceObject.kpis){
            performanceObject.summaryCount = performanceObject.summaryCount + kpi.kpiResults.length;                       
          }
          if(performanceObject.summaryCount !== 0){
            performanceObject.hasData = true;
            for(const kpi of performanceObject.kpis){
              const falseComplianceCount = kpi.kpiResults.filter((kpiResult: any) => kpiResult.compliance === false).length;
              // console.log(`others iteration, kpiName = ${kpi.kpiName}`);
              // console.log(`others iteration, falseComplianceCount = ${falseComplianceCount}`);
              if(falseComplianceCount > 0){
                performanceObject.falseComplianceCount = performanceObject.falseComplianceCount + falseComplianceCount;
              }
            }             
          }
        }
        if(performanceObject.catergoryId === 'S'){
          performanceObject.summaryCount = 0;
          for(const kpi of performanceObject.kpis){
            performanceObject.summaryCount = performanceObject.summaryCount + kpi.kpiResults.length;
          }
        }
        if(performanceObject.catergoryId === 'T'){
          performanceObject.summaryCount = 0;
          for(const kpi of performanceObject.kpis){
            performanceObject.summaryCount = performanceObject.summaryCount + kpi.kpiResults.length;
          }
        }
      }
    }

  }


}

